import React, { Fragment } from "react";
import {makeStyles} from "@material-ui/core/styles"
import ForegroundImage from "./ForegroundImage";
import BackgroundImage from "./BackgroundImage";
import TextDescription from "./TextDescription";

function CarouselSlide({ slidedata, heightClass, isForeground, isTimer , onRemoveCDT}) {
  let assetType = slidedata.assetType;
  //isForeground=false;// enable this to test No-foreground case
  let containerStyle = makeStyles({
    root:{
      justifyContent:"center !important",
      "&.small-carousel":isForeground?{height:  "515px !important"}:{}
    },
    withCDT : {
      // minHeight : "495px !important"
    },
    termsContainer : {
      justifyContent:"center",
      maxWidth:"100vw !important",
      "& .carousel-terms": {
        display: "flex",
        justifyContent:"center",
        maxWidth:"100vw !important",
        "& .carousel-terms-para":{
          textAlign:"center",
          maxWidth:"80vw !important"
        }
      }
    },
    // smallCarousel:{
      
    // }
  })

  let classes = heightClass.toLowerCase();
  const isTermsAndCondition= slidedata.termsAndCondition != undefined;
  return (
    <div className={`carousel-slide ${classes.toLowerCase()} ${!isForeground ? containerStyle().root :"small-carousel-with-foreground"} ${isTermsAndCondition?"mobile-with-terms":""}`}>
      {/* slide background image */}
      <BackgroundImage image={slidedata.backgroundImage}/>

        
      {/* checking asset types image/video */}
      {assetType === "image" ? (
        <Fragment>
          <TextDescription onRemoveCDT={onRemoveCDT} textContent={slidedata.textContent} countdownTimer={slidedata.countdownTimer} ctaButton={slidedata.ctaButton} isAlignCenter={!isForeground}/>
          {isForeground?<ForegroundImage image={{ src: slidedata.foregroundImage.fgAssetPath, alt: slidedata.foregroundImage.fgAltText }} isTermsAndCondition={isTermsAndCondition} />:""}
        </Fragment>
      ) : (
        ""
      )}

        
      {/* terms & condition */}
      { slidedata.termsAndCondition != undefined &&  <div className={`carousel-terms-container  carousel-terms-align-center`} >
        <div className="carousel-terms">
              <p className="carousel-terms-para" style={{color:slidedata.termsAndCondition.termsAndConditionColor}}>
                {slidedata.termsAndCondition.termsAndConditionText}
              </p>
        </div>
     </div>}
    </div>
  );
}

export default CarouselSlide;
